<nz-page-header
  class="site-page-header"
  nzBackIcon
  [nzTitle]="idForUpdate ? 'Update Coupon' : 'Add Coupon'"
>
</nz-page-header>
<form nz-form [formGroup]="addUpdateCouponForm">
  <nz-card nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
      <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="couponTitle" nzRequired
                >Title</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <input
                  nz-input
                  formControlName="couponTitle"
                  type="text"
                  placeholder="Enter Title "
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="couponCode" nzRequired
                >Code</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <input
                  nz-input
                  formControlName="couponCode"
                  type="text"
                  placeholder="Enter Code"
                  (input)="onCouponInput($event)"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="description" nzRequired
                >Description</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <textarea
                  rows="2"
                  nz-input
                  formControlName="description"
                  placeholder="Enter description"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="discountType" nzRequired
                >Discount Type</nz-form-label
              >
              <nz-form-control
                [nzSpan]="24"
                nzErrorTip="Please select discount type"
              >
                <nz-select
                  nzAllowClear
                  formControlName="discountType"
                  nzPlaceHolder="Select discount type"
                  (ngModelChange)="onDiscountTypeChange($event)"
                >
                  <nz-option
                    *ngFor="let item of allDiscountType"
                    nzValue="{{ item.value }}"
                    nzLabel="{{ item.label }}"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="discountValue" nzRequired
                >Discount Value</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <nz-input-group [nzAddOnAfter]="displayValueRupee ? '₹' : '%'">
                  <input
                    type="text"
                    nz-input
                    formControlName="discountValue"
                    placeholder="Enter value"
                  />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="maxDiscountValue" nzRequired
                >Max Discount Value</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <input
                  type="number"
                  nz-input
                  formControlName="maxDiscountValue"
                  placeholder="Enter value"
                  [disabled]="displayValueRupee"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="distributeLimit"
                >Distribute Limit</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <input
                  nz-input
                  formControlName="distributeLimit"
                  type="number"
                  placeholder="Enter limit "
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="startDate" nzRequired
                >Start Date
              </nz-form-label>
              <nz-form-control
                nzErrorTip="Should not be blank or previous date or same than End Date"
              >
                <nz-date-picker
                  class="width-100"
                  formControlName="startDate"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="endDate" nzRequired
                >End Date
              </nz-form-label>
              <nz-form-control nzErrorTip="Should not be blank">
                <nz-date-picker
                  class="width-100"
                  formControlName="endDate"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="applyForCoupon" nzRequired
                >Coupon will be applied for</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Please select ">
                <nz-select
                  nzAllowClear
                  formControlName="applyForCoupon"
                  nzPlaceHolder="Select type"
                  (ngModelChange)="onCouponForChange($event)"
                >
                  <nz-option
                    *ngFor="let item of couponFor"
                    nzValue="{{ item.value }}"
                    nzLabel="{{ item.label }}"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div
            nz-col
            nzLg="24"
            nzMd="24"
            nzSm="24"
            nzXs="24"
            *ngIf="couponForValue === 'PLAN'"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="plans">Plans </nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <nz-select
                  [nzLoading]="loadingPlans"
                  (nzOnSearch)="onSearch($event)"
                  nzAllowClear
                  nzShowSearch
                  nzServerSearch
                  (nzScrollToBottom)="loadMorePlans()"
                  [nzMaxTagCount]="15"
                  nzMode="tags"
                  nzPlaceHolder="Please select"
                  formControlName="plans"
                >
                  <nz-option
                    *ngFor="let item of listOfPlans"
                    [nzLabel]="item.name"
                    [nzValue]="item._id"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div
            nz-col
            nzLg="24"
            nzMd="24"
            nzSm="24"
            nzXs="24"
            *ngIf="couponForValue === 'TEST_SERIES'"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="testSeries"
                >Test Series</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <nz-select
                  [nzLoading]="loadingSeries"
                  (nzOnSearch)="onSearchSeries($event)"
                  nzAllowClear
                  nzShowSearch
                  nzServerSearch
                  (nzScrollToBottom)="loadMoreSeries()"
                  [nzMaxTagCount]="15"
                  nzMode="tags"
                  nzPlaceHolder="Please select"
                  formControlName="testSeries"
                >
                  <nz-option
                    *ngFor="let item of listOfSeries"
                    [nzLabel]="item.name"
                    [nzValue]="item._id"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div
            nz-col
            nzLg="24"
            nzMd="24"
            nzSm="24"
            nzXs="24"
            *ngIf="couponForValue === 'USER'"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="users">Users</nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <nz-select
                  [nzLoading]="loadingUsers"
                  (nzOnSearch)="onSearchUser($event)"
                  nzAllowClear
                  nzShowSearch
                  nzServerSearch
                  (nzScrollToBottom)="loadMoreUsers()"
                  [nzMaxTagCount]="15"
                  nzMode="tags"
                  nzPlaceHolder="Please select"
                  formControlName="users"
                >
                  <nz-option
                    *ngFor="let user of listOfUser"
                    [nzValue]="user._id"
                    [nzLabel]="user.name"
                    [nzCustomContent]="true"
                  >
                    <div style="display: flex; flex-direction: column">
                      <span>
                        <i
                          nz-icon
                          nzType="user"
                          nzTheme="outline"
                          *ngIf="user.name"
                        ></i>
                        {{ user.name }}
                      </span>
                      <span style="color: #666; font-size: 0.9em">
                        <i
                          nz-icon
                          nzType="mail"
                          nzTheme="outline"
                          *ngIf="user.email"
                        ></i>
                        {{ user.email }}
                      </span>
                      <span style="color: #666; font-size: 0.9em">
                        <i
                          nz-icon
                          nzType="phone"
                          nzTheme="outline"
                          *ngIf="user.mobile"
                        ></i>
                        {{ user.mobile }}
                      </span>
                    </div>
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
    </div>

    <div nz-row nzJustify="end">
      <button
        nz-button
        nzType="primary"
        [nzLoading]="buttonLoading"
        (click)="submit()"
        class="submitoraddbutton"
      >
        {{ idForUpdate ? "Update" : "Submit" }}
      </button>
    </div>
  </nz-card>
</form>
